/* documentViewer.tsx generated by @compiled/babel-plugin v0.38.1 */
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "./documentViewer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useLayoutEffect, useRef } from 'react';
import { Page } from './page';
import { usePageContent } from './usePageContent';
import { getScrollElement } from './utils/getDocumentRoot';
import { useCachedGetImage } from './utils/useCachedGetImage';
var documentViewerStyles = null;
var DEFAULT_PAGINATION_SIZE = 50;
var DEFAULT_MAX_PAGE_IMAGE_ZOOM = 6;
export var DocumentViewer = function DocumentViewer(_ref) {
  var _documentMetadata$pag;
  var onSuccess = _ref.onSuccess,
    getContent = _ref.getContent,
    getPageImageUrl = _ref.getPageImageUrl,
    _ref$paginationSize = _ref.paginationSize,
    paginationSize = _ref$paginationSize === void 0 ? DEFAULT_PAGINATION_SIZE : _ref$paginationSize,
    _ref$maxPageImageZoom = _ref.maxPageImageZoom,
    maxPageImageZoom = _ref$maxPageImageZoom === void 0 ? DEFAULT_MAX_PAGE_IMAGE_ZOOM : _ref$maxPageImageZoom,
    zoom = _ref.zoom;
  var _usePageContent = usePageContent(getContent, paginationSize),
    getPageContent = _usePageContent.getPageContent,
    loadPageContent = _usePageContent.loadPageContent,
    documentMetadata = _usePageContent.documentMetadata;
  var getImageUrl = useCachedGetImage(getPageImageUrl, maxPageImageZoom);
  var style = {
    '--document-viewer-zoom': zoom
  };
  var previousZoomRef = useRef(zoom);

  // Apply zoom with center-based adjustment
  useLayoutEffect(function () {
    var previousZoom = previousZoomRef.current;

    // Only adjust scroll if zoom actually changed
    if (previousZoom !== zoom) {
      // If we are not using a custom scroll element, we don't need to adjust the scroll position
      var container = getScrollElement();
      if (!container) {
        return;
      }

      // Calculate the center point of the viewport before zoom
      var viewportCenterX = container.scrollLeft + container.clientWidth / 2;
      var viewportCenterY = container.scrollTop + container.clientHeight / 2;

      // Calculate scale difference
      var scaleDiff = zoom / previousZoom - 1;

      // Adjust scroll to keep center point fixed
      container.scrollLeft += viewportCenterX * scaleDiff;
      container.scrollTop += viewportCenterY * scaleDiff;

      // Update previous zoom
      previousZoomRef.current = zoom;
    }
  }, [zoom]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "document-viewer",
    style: style,
    className: ax(["_zulputpp _1reo1wug _18m91wug _19pkxncg _1ul91osq _1e0c1txw _2lx21bp4"])
  }, _toConsumableArray(Array((_documentMetadata$pag = documentMetadata.pageCount) !== null && _documentMetadata$pag !== void 0 ? _documentMetadata$pag : 4)).map(function (_, i) {
    var _getPageContent = getPageContent(i),
      page = _getPageContent.page,
      fonts = _getPageContent.fonts;
    return /*#__PURE__*/React.createElement(Page, {
      key: i,
      getPageSrc: getImageUrl,
      maxPageImageZoom: maxPageImageZoom,
      pageIndex: i,
      zoom: zoom,
      defaultDimensions: documentMetadata.defaultDimensions,
      onVisible: function onVisible() {
        return loadPageContent(i);
      },
      onLoad: i === 0 ? onSuccess : undefined,
      fonts: fonts,
      content: page
    });
  }));
};